import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 各子组件引入
import cockpit from "./tab/cockpit";
import meteorological from "./tab/meteorological";
import spectrum from "./tab/spectrum";
import moment from 'moment';
import { mapActions } from 'vuex'; // 全屏

import screenfull from 'screenfull';
export default {
  components: {
    cockpit: cockpit,
    meteorological: meteorological,
    spectrum: spectrum
  },
  data: function data() {
    return {
      titleLogo: '',
      waterName: '',
      headDate: '',
      headTime: '',
      selectIndex: 0,
      selectId: 0,
      isFullscreen: false,
      tabList: [{
        id: 0,
        name: '驾驶舱'
      } // {
      //   id: 2,
      //   name: '气象分析',
      // },
      // {
      //   id: 3,
      //   name: '光谱分析',
      // }
      ]
    };
  },
  created: function created() {
    console.log('enter');
    this.titleLogo = window.localStorage.getItem('titleLogo');
    this.waterName = window.localStorage.getItem('waterName');

    if (this.$route.query.tab) {
      this.selectIndex = this.tabList.length - 1;
      this.selectId = this.tabList[this.selectIndex].id;
      this.$router.replace({
        query: ''
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      var date = new Date();
      _this.headDate = moment(date).format('YYYY年MM月DD日');
    }, 60000);
    this.getDate();
  },
  methods: _objectSpread(_objectSpread({
    turnTosite: function turnTosite(value) {
      if (value) {
        this.selectIndex = this.tabList.length - 1;
        this.selectId = this.tabList[this.selectIndex].id;
      }
    },
    getDate: function getDate() {
      var _this2 = this;

      var date = new Date();
      this.headDate = moment(date).format('YYYY年MM月DD日');
      this.headTime = moment(date).format('HH:mm:ss');
      setInterval(function () {
        var time = new Date();
        _this2.headTime = moment(time).format('HH:mm:ss');

        _this2.$forceUpdate();
      }, 1000);
    },
    // 点击头部导航栏
    onToTab: function onToTab(id, index) {
      console.log('id......', id);
      this.selectIndex = index;
      this.selectId = id;
    },
    fullscreen: function fullscreen() {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
    goHome: function goHome() {
      this.$router.push('/monitor/map');
    }
  }, mapActions(['Logout'])), {}, {
    logout: function logout() {
      var that = this;
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: function onOk() {
          return that.Logout({}).then(function () {
            window.location.href = '/'; //window.location.reload()
          }).catch(function (err) {
            that.$message.error({
              title: '错误',
              description: err.message
            });
          });
        },
        onCancel: function onCancel() {}
      });
    }
  })
};